export const mockDemands = [
  {
    id: 'D-2026-0142',
    title: '古装仙侠短剧剧本创作及后期制作需求',
    type: '剧本创作 + 制作',
    tags: ['仙侠', '古装', '竖屏短剧'],
    budget: '15 - 30 万元',
    region: '全国均可（线上协作）',
    publishedAt: '2026-07-25',
    views: 1284,
  },
  {
    id: 'D-2026-0139',
    title: '现代都市甜宠短剧 30 集后期剪辑合作',
    type: '后期剪辑',
    tags: ['都市', '甜宠', '30集'],
    budget: '8 - 15 万元',
    region: '北京 / 上海 / 远程',
    publishedAt: '2026-07-23',
    views: 956,
  },
  {
    id: 'D-2026-0136',
    title: '海外本地化短剧（英语/西班牙语）配音与字幕',
    type: '本地化服务',
    tags: ['海外发行', '英语', '西班牙语'],
    budget: '5 - 12 万元',
    region: '海外团队优先',
    publishedAt: '2026-07-20',
    views: 743,
  },
  {
    id: 'D-2026-0131',
    title: 'AI 辅助竖屏短剧批量生产方案（20集起）',
    type: 'AI 创作',
    tags: ['AI制作', '竖屏', '批量'],
    budget: '洽谈',
    region: '全国',
    publishedAt: '2026-07-18',
    views: 612,
  },
];

export const mockSolutions = [
  {
    id: 'S-2026-0088',
    title: '专业短剧全案制作方案（古装 / 现代 / 悬疑）',
    categories: ['全案制作', '后期包装'],
    scenes: ['古装仙侠', '现代都市', '悬疑犯罪'],
    summary: '深耕短剧赛道 5 年，完成超 200 部作品，具备完整自建团队，涵盖编剧、拍摄、剪辑、配音全流程',
    region: '北京 / 可远程',
    publishedAt: '2026-07-24',
    rating: 4.9,
  },
  {
    id: 'S-2026-0084',
    title: 'AI 辅助高效剪辑与智能字幕解决方案',
    categories: ['AI 剪辑', '字幕处理'],
    scenes: ['所有题材', '海外发行'],
    summary: '利用自研 AI 剪辑工具，将单集剪辑周期从 3 天压缩至 8 小时，支持多语言字幕自动生成与校对',
    region: '全国 / 全球',
    publishedAt: '2026-07-22',
    rating: 4.8,
  },
  {
    id: 'S-2026-0079',
    title: '海外短剧本地化运营与发行推广方案',
    categories: ['海外运营', '本地化'],
    scenes: ['TikTok', '海外APP', '跨境发行'],
    summary: '专注东南亚、北美市场本地化，合作海外 MCN 超 30 家，单部剧最高实现 2000 万海外播放',
    region: '海外团队',
    publishedAt: '2026-07-20',
    rating: 4.7,
  },
  {
    id: 'S-2026-0073',
    title: '竖屏短剧视觉包装与营销素材制作方案',
    categories: ['视觉设计', '营销素材'],
    scenes: ['宣传片', '封面设计', '剪辑花絮'],
    summary: '提供从主封面设计到营销切片全套视觉方案，助力内容在各平台获得更高推荐权重',
    region: '上海 / 远程',
    publishedAt: '2026-07-17',
    rating: 4.6,
  },
];

export const mockStats = [
  { value: '500+', label: '合作内容方', icon: 'ri-user-star-line' },
  { value: '12', label: '覆盖发行渠道', icon: 'ri-broadcast-line' },
  { value: '3,200+', label: '成功发行剧集', icon: 'ri-film-line' },
  { value: '¥2.8亿+', label: '累计结算收益', icon: 'ri-money-cny-circle-line' },
];

export const mockChannels = [
  {
    name: 'TikTok',
    desc: '全球最大短视频平台，月活超 15 亿',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20TikTok%20inspired%20app%20icon%20design%20featuring%20a%20stylized%20white%20musical%20note%20symbol%20on%20pure%20deep%20black%20circular%20background%20with%20subtle%20cyan%20and%20magenta%20gradient%20accent%20ring%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-tiktok-01&orientation=squarish',
    badge: '海外首选',
  },
  {
    name: '抖音',
    desc: '国内短视频龙头，精准推荐算法',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20Douyin%20inspired%20app%20icon%20design%20featuring%20a%20stylized%20white%20musical%20note%20or%20sound%20wave%20symbol%20on%20deep%20dark%20background%20with%20vibrant%20red%20to%20pink%20gradient%20accent%20circle%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-douyin-01&orientation=squarish',
    badge: '国内首选',
  },
  {
    name: '红果短剧',
    desc: '字节旗下专属短剧平台，高付费转化',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20drama%20streaming%20app%20icon%20design%20featuring%20a%20stylized%20white%20play%20button%20triangle%20symbol%20on%20warm%20gradient%20orange%20to%20coral%20red%20circular%20background%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-hongguo-01&orientation=squarish',
    badge: '付费首选',
  },
  {
    name: '微信视频号',
    desc: '微信生态内容分发，私域转化优势',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20WeChat%20Channels%20video%20platform%20app%20icon%20design%20featuring%20a%20stylized%20white%20play%20button%20symbol%20on%20fresh%20vibrant%20green%20circular%20background%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-wechat-01&orientation=squarish',
    badge: '私域运营',
  },
  {
    name: '自营海外 APP',
    desc: '平台自营出海内容APP，定向推广',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20global%20streaming%20platform%20app%20icon%20design%20featuring%20a%20stylized%20white%20globe%20and%20play%20button%20combination%20symbol%20on%20gradient%20deep%20navy%20to%20teal%20circular%20background%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-overseas-01&orientation=squarish',
    badge: '独家渠道',
  },
  {
    name: '更多渠道',
    desc: '持续接入优质发行渠道，敬请期待',
    logoImage: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20vector%20style%20app%20icon%20design%20featuring%20a%20stylized%20white%20plus%20sign%20inside%20a%20network%20grid%20or%20constellation%20dot%20pattern%20on%20gradient%20deep%20purple%20to%20violet%20circular%20background%20modern%20app%20store%20presentation%20centered%20symmetrical%20composition%20soft%20shadow%20high%20quality%20icon%20design%20on%20light%20gray%20studio%20backdrop&width=200&height=200&seq=channel-more-01&orientation=squarish',
    badge: '持续扩展',
  },
];

export const workflowSteps = [
  {
    step: '01',
    title: '提交申请',
    desc: '填写剧集基础信息、上传正片素材、完善权属证明文件',
    icon: 'ri-file-text-line',
  },
  {
    step: '02',
    title: '平台审核',
    desc: '专业团队人工审核内容合规性与版权真实性',
    icon: 'ri-shield-check-line',
  },
  {
    step: '03',
    title: '线下签约',
    desc: '确认分渠道合作条款快照，签署正式发行合同',
    icon: 'ri-pen-nib-line',
  },
  {
    step: '04',
    title: '渠道发布',
    desc: '多平台同步提交，独立跟踪每个渠道的上线状态',
    icon: 'ri-rocket-line',
  },
  {
    step: '05',
    title: '数据归集',
    desc: '实时汇总各渠道播放量、完播率、付费转化等多维数据',
    icon: 'ri-bar-chart-2-line',
  },
  {
    step: '06',
    title: '收益结算',
    desc: '透明账单对账、按合同约定周期发起结算，付款凭证可追溯',
    icon: 'ri-money-cny-circle-line',
  },
];
/* ── 新版首页（三屏整页翻页）数据 ── */

export type HomeTone = 'green' | 'purple' | 'blue' | 'orange'

export interface HomeSideAction {
  title: string
  subtitle: string
  icon: string
  tone: HomeTone
  to: string
}

export interface HomeCreatorStat {
  value: string
  label: string
}

export interface HomeEcosystemCard {
  title: string
  description: string
  icon: string
  tone: HomeTone
  imageKey: 'supply' | 'course' | 'distribution'
  tags: string[]
  primary: string
  secondary?: string
  to: string
}

export interface HomeDemandCard {
  type: string
  icon: string
  tone: HomeTone
  title: string
  description: string
  role: string
  budget: string
  location: string
  time: string
}

export const homeSideActions: HomeSideAction[] = [
  { title: '开始创作', subtitle: 'AI一键生成短剧', icon: 'play', tone: 'green', to: 'https://www.xuyingai.com/home' },
  { title: '剧本工坊', subtitle: '优质剧本共创计划', icon: 'clapperboard', tone: 'purple', to: '/talents' },
  { title: '达人招募', subtitle: '加入共创收益计划', icon: 'users-round', tone: 'orange', to: '/demands' },
]

export const homeCreatorStats: HomeCreatorStat[] = [
  { value: '1,280+', label: '创作者已入驻' },
  { value: '326', label: '项目正在共创' },
]

export const homeEcosystemCards: HomeEcosystemCard[] = [
  { title: '供需平台', description: '企业个人发布需求，快速找到合适的人一起拍。', icon: 'users-round', tone: 'green', imageKey: 'supply', tags: ['需求发布', '人才招募', '案例展示'], primary: '去找项目', secondary: '发布需求', to: '/demands' },
  { title: '优质课程', description: '从剧本、分镜到成片，系统掌握 AI 短剧工作流。', icon: 'book-open', tone: 'purple', imageKey: 'course', tags: ['录播课程', '案例拆解', '实战训练'], primary: '浏览课程', to: '/courses' },
  { title: '海内外发行', description: '让好故事被更多观众看见，连接国内外发行渠道。', icon: 'globe-2', tone: 'blue', imageKey: 'distribution', tags: ['平台发行', '海外市场', '合作咨询'], primary: '了解发行服务', to: '/distribution' },
]

export const homeDemandCards: HomeDemandCard[] = [
  { type: '竖屏短剧', icon: 'file-text', tone: 'green', title: '古风悬疑竖屏短剧《夜行录》\n招募编剧与 AI 视频师', description: '全20集古风悬疑题材，已完成世界观设定和前三集剧本，寻找擅长古风场景的 AI 视频师合作。', role: '编剧、AI视频师', budget: '3-5万/集', location: '北京 · 可远程', time: '2天前' },
  { type: '品牌短剧', icon: 'message-circle', tone: 'purple', title: '品牌短剧《新职场人》\n寻求导演与后期剪辑', description: '为某互联网品牌定制的职场成长短剧，共12集，每集3-5分钟，需要导演和后期剪辑团队。', role: '导演、后期', budget: '8-12万', location: '上海', time: '5天前' },
  { type: '海外短剧', icon: 'globe-2', tone: 'blue', title: '海外短剧《Love in Tokyo》\n寻找日语配音演员', description: '面向日本市场的浪漫短剧，已完成AI画面生成，现需日语母语配音演员2-3名。', role: '配音', budget: '按集计费', location: '远程 · 可远程', time: '1天前' },
  { type: '竖屏短剧', icon: 'file-text', tone: 'green', title: '科幻题材短剧《星际快递》\n招募制片人与概念设计师', description: '硬核科幻喜剧短剧，需要统筹项目全流程的制片人和负责视觉概念的设计师。', role: '制片、设计', budget: '15-20万', location: '深圳 · 可远程', time: '3天前' },
]
